






























































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import TimeZoneCard from "@/components/form/TimeZoneCard.vue";
import CommonInputModal from "@/components/common/CommonInputModal.vue";
import CommonButton from "@/components/common/CommonButton.vue";
import CommonInput from "@/components/common/CommonInput.vue";
import LessonItem from "@/components/other/LessonItem.vue";
import AddLesson from "@/components/form/AddLesson.vue";

@Component({
  components: {
    AddLesson,
    LessonItem,
    CommonInput,
    TimeZoneCard,
    CommonInputModal,
    CommonButton
  },
})
export default class LessonsInput extends Vue {
  private isShow:boolean = false;
  private inputData:string = ''
  private list:Array<any> = [];
  private isAddLesson:boolean = false;

  @Prop()
  private value!: string;

  @Prop()
  private label?: string;

  @Prop()
  private name?: string;

  @Prop()
  private rules?: Array<any>;

  @Prop({default: []})
  private lessons!: Array<any>;

  @Prop({default: ''})
  private errorMessage!: string;

  @Prop({default: false})
  private disabled!: boolean;

  @Prop({default: false})
  private dark!: boolean;

  @Prop()
  private color?: string;

  @Prop({default: false})
  private dense?: boolean;

  @Prop({default: true})
  private rounded?: boolean;

  @Watch('value')
  watchPropValue() {
    this.inputData = this.value;
  }

  @Watch('lessons')
  watchPropLessons() {
    this.list = [...this.lessons];
  }

  private mounted () {
    this.list = [...this.lessons];
    if (this.lessons.length > 0) {
      this.inputData = this.lessons.length + ' lessons attached';
    }
  }

  private changeShow(show:boolean) {
    this.isShow = show;
  }

  private handleCancel() {
    this.list = [...this.lessons];
    if (this.lessons.length > 0) {
      this.inputData = this.lessons.length + ' lessons attached';
    }
    this.isShow = false;
    this.$emit('updateLessons', this.lessons);
  }

  private handleSelect() {
    if (this.list.length > 0) {
      this.inputData = this.list.length + ' lessons attached';
    }
    this.isShow = false;
    this.$emit('updateLessons', this.list);
  }

  private handleRemoveLesson(index:number) {
    this.list.splice(index, 1);
  }

  private handleAddLesson(lesson:any) {
    this.isAddLesson = false;
    this.list.push(lesson);
  }
}
